import * as React from 'react';
import { ICreateShopObject } from 'models/shop/createshop';
import { InjectedRouter } from 'react-router';
import { ShopMembers } from 'containers/Shop/Common/ShopMembers';

interface IProps {
	router: InjectedRouter;
	route: any;
	previousPage?: () => void;
	onSubmit?: (form: ICreateShopObject) => void;
	customMemberClassName: string;
}
const CreateShopStepMembers = (props: IProps) => <ShopMembers {...props} redux="createShop" />;

export { CreateShopStepMembers };
